module.exports = __webpack_public_path__ + "static/media/google.654174d8.png";